
export default {
  name: 'VideoSlice',
  props: ['slice'],
  computed: {
    videoId() {
      return this.slice.primary.url?.embed_url?.substr(
        this.slice.primary.url.embed_url.indexOf('v=') + 2,
        this.slice.primary.url.embed_url.length
      )
    }
  }
}
